import { css } from "@emotion/react";

export const linkCss = css`
  cursor: pointer;
  display: block;
  padding: 0.5rem 0;
  text-decoration: none;
  line-height: 2rem;
`;
